import Prismic from 'prismic-javascript'

export const endpoint = "https://armstrong-project.cdn.prismic.io/api/v2"


export const client = () =>{
  return Prismic.client(endpoint)
}
